var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnFullscreen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7107 6.62366L15.7811 1.55322M15.7811 1.55322V4.08844V4.72225M15.7811 1.55322L13.2459 1.55322H12.6121M6.27405 6.62366L1.20361 1.55322M1.20361 1.55322H3.73883H4.37264M1.20361 1.55322V4.08844V4.72225M6.27405 11.0603L1.20361 16.1307M1.20361 16.1307V12.9617M1.20361 16.1307H4.37264M10.7107 11.0603L15.7811 16.1307M15.7811 16.1307V12.9617M15.7811 16.1307H13.2459H12.6121",
    stroke: "white",
    strokeWidth: 1.19471
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnFullscreen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-fullscreen.2e76cc7c.svg";
export { ForwardRef as ReactComponent };